// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTooltip-cls1_xkJ","cls2":"UserTooltip-cls2_jfO UserTooltip-cls1_xkJ"};